import { createIcon } from "@chakra-ui/react";

const CloseIcon = createIcon({
  displayName: "CloseIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M10.7626 11.9996L5.38086 17.3813L6.6183 18.6188L12 13.2371L17.3817 18.6188L18.6191 17.3813L13.2374 11.9996L18.6183 6.61879L17.3809 5.38135L12 10.7622L6.61914 5.38135L5.3817 6.61878L10.7626 11.9996Z"
        fill="currentColor"
      />
    </>
  ),
});

export default CloseIcon;
